<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_DETALHAR_COMANDA')">
            <div class="z-1 text-center">
                <div class="text-900 font-bold text-7xl mb-4">Acesso Negado</div>
                <p class="line-height-3 mt-0 mb-5 text-700 text-xl font-medium">
                    Voçê não possui permissão de acesso a esta página
                </p>
                <p-button
                    [routerLink]="['/apps/caixa']"
                    styleClass="p-button-help font-medium p-button-raised"
                >
                    Voltar
                </p-button>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_DETALHAR_COMANDA')">
            <h4>Transferência de Crédito</h4>
            <form>
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                    </div>

                    <div class="flex justify-content-center" *ngIf="isExibirSpinnerPrincipal()">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </div>
                <div class="formgroup" *ngIf="transferenciaCredito && !isExibirSpinnerPrincipal()">
                    <div class="p-fluid p-formgrid grid pt-5 px-3">
                        <div class="col-12 card-simple">
                            <div class="p-fluid p-formgrid grid">
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Data</label>
                                    <label class="label-inferior">
                                        {{ transferenciaCredito.data | date: "dd/MM/yyyy" }}
                                    </label>
                                </div>
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">De:</label>
                                    <label class="label-inferior">
                                        {{ transferenciaCredito.nomeClienteOrigem }}
                                    </label>
                                </div>
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Para:</label>
                                    <label class="label-inferior">
                                        {{ transferenciaCredito.nomeClienteDestino }}
                                    </label>
                                </div>

                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Valor</label>
                                    <label class="label-inferior">
                                        {{
                                            transferenciaCredito.valorTransferido | currency: "BRL"
                                        }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
